export default __webpack_public_path__ + "84e0743bdbc0ca1b3d03133d28de3174.png";